import React from 'react';
import { Icon, Tooltip, Typography } from '@saviynt/design-system';

import { useInvertedLocalize } from '../../../shared/utils/localization';

import styles from './ClaimsTooltip.module.css';

interface ClaimsTooltipProps {
  claims?: Record<string, string>;
}

/**
 * Renders "N Claims" text with an info icon that shows a tooltip listing
 * all claim key-value pairs on hover (per Figma).
 * Renders nothing when there are 0 claims.
 */
export function ClaimsTooltip({
  claims,
}: ClaimsTooltipProps): JSX.Element | null {
  const l = useInvertedLocalize();

  const claimEntries = Object.entries(claims ?? {});
  const count = claimEntries.length;

  if (count === 0) {
    return null;
  }

  const label = l('{count, plural, one {# claim} other {# claims}}', {
    count,
  });

  // Plain string with newlines — Tooltip requires string `text` (non-string triggers
  // isTextEmpty check that hides the tooltip). CSS white-space: pre-line renders \n.
  const tooltipText = claimEntries
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');

  return (
    <div className={styles.ClaimsTooltip}>
      <Typography kind='body2'>{label}</Typography>
      <Tooltip text={tooltipText} className={styles.ClaimsTooltip_tooltip}>
        <Icon
          kind='AlertInfoFilled'
          color='--color-foreground-neutral-subtle'
          size='small'
          label=''
        />
      </Tooltip>
    </div>
  );
}
